import { Grid, Divider, Typography, Box } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { Control, UseFormReset, UseFormSetValue, useWatch } from "react-hook-form";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { callAPI, getLocalValue, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import SlotAvailabilityCalendar from "./SlotAvailabilityCalender";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSTimePicker from "../../../Components/WSTimePicker/WSTimePicker";
import WSSCheckBoxField from "../../../Components/CheckBox/WSCheckBox";

interface SlotDrawerProps {
  control: Control<any>;
  id: string;
  reset: UseFormReset<any>;
  setValue: UseFormSetValue<any>;
  onCancel: () => void;
  onSuccess?: () => void;
}

const SlotDrawer: React.FC<SlotDrawerProps> = ({
  control, 
  id, 
  reset, 
  setValue, 
  onCancel, 
  onSuccess
}) => {
  const { showMessage } = useSnackbar();
  const [labId, setLabId] = useState("");

  const formValues = useWatch({ control });

  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setLabId(userId || "");
  }, []);

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    
    const duration = parseInt(formValues?.durationInMinutes || "0");
    if (!formValues?.date || !formValues?.startTime || !formValues?.endTime || duration <= 0) {
      showMessage("Please fill ALL fields correctly", "error");
      return;
    }

    try {
      // 🔥 FIXED: Root array + exact API structure
      const payload = [
        {
          labId: labId.toUpperCase(),
          days: [
            {
              day: formValues.date,
              slots: [
                {
                  durationInMinutes: duration,
                  startTime: `${formValues.startTime}:00`,
                  endTime: `${formValues.endTime}:00`,
                  isAvailable: true
                }
              ]
            }
          ]
        }
      ];

      console.log("✅ FINAL PAYLOAD:", JSON.stringify(payload, null, 2));
      
      const response = await callAPI(`lab/LabSlot`, Method.POST, payload);
      console.log("✅ RESPONSE:", response);
      
      showMessage("✅ Slot created successfully!", "success");
      reset();
      onSuccess?.();
      onCancel();
      
    } catch (error: any) {
      console.error("❌ FULL ERROR:", error);
      console.error("❌ RESPONSE DATA:", error.response?.data);
      console.error("❌ STATUS:", error.response?.status);
      const errorMsg = error.response?.data?.message || error.response?.data || "Failed to create slot";
      showMessage(errorMsg, "error");
    }
  }, [formValues, labId, reset, onSuccess, onCancel, showMessage]);

  return (
    <form id={id} onSubmit={handleSubmit} style={{ height: "100%" }}>
      <Grid container spacing={2} sx={{ p: 2, height: "100%" }}>
        {/* 1. DURATION */}
        <Grid item xs={12}>
          <WSTextField
            control={control}
            name="durationInMinutes"
            id="durationInMinutes"
            rules={{ 
              required: "Duration required",
              pattern: { value: /^[0-9]+$/, message: "Enter number" }
            }}
            label="Duration (minutes)*"
            type={TextType.Number}
          />
        </Grid>

        {/* 2. DATE PICKER */}
        <Grid item xs={12}>
          <SlotAvailabilityCalendar
            setValue={(name, value) => {
              console.log("📅 Date selected:", value);
              setValue("date", value, { shouldValidate: true });
            }}
          />
        </Grid>

        {/* 3. TIME PICKERS */}
        <Grid item xs={12} sm={6}>
          <WSTimePicker
            control={control}
            name="startTime"
            id="startTime"
            label="Start Time*"
            rules={{ required: "Start time required" }}
            timeSize="small"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <WSTimePicker
            control={control}
            name="endTime"
            id="endTime"
            label="End Time*"
            rules={{ required: "End time required" }}
            timeSize="small"
          />
        </Grid>

        {/* 4. AVAILABILITY - 🔥 FIXED: Removed rules prop */}
        <Grid item xs={12}>
          <WSSCheckBoxField
  control={control}
  name="isAvailable"
  id="isAvailable"
  label="Mark as Available"
  switchType="IOS"
  rules={{ required: "Availability required" }}
/>

        </Grid>

        {/* 5. LAB ID DISPLAY */}
        <Grid item xs={12}>
          <Divider sx={{ my: 3 }} />
          <Box sx={{ opacity: 0.7 }}>
            <Typography variant="caption">
              Lab ID: <strong>{labId || "Loading..."}</strong>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};

export default SlotDrawer;

